import defaultClient from '@src/api/clients/default';

const URL = (path = '') => {
    return `dashboard/clients/${path}`; // Ensure the correct path here
  };
  

export function fetchClients() {
  return defaultClient.request({
    url: URL(''), // This will correctly hit /api/clients/
  });
}

export function quickCreateClient(payload = {}) {
  return defaultClient.request({
    url: 'app1/clients/quick-create/',
    method: 'POST',
    payload,
  });
}

export function fetchClient(slugOrId) {
  if (!slugOrId) {
    return Promise.reject(new Error('Client slug or id is required'));
  }

  return defaultClient.request({
    url: URL(`${slugOrId}/`),
  });
}
